const r = (e) => {
  for (let t = e.length - 1; t >= 0; t--)
    if (typeof e[t].order == "number")
      return { data: e[t], index: t };
}, o = (e, t, n) => {
  if (t >= 0 && t <= e.length)
    e.splice(t, 0, n);
  else
    throw new Error("Index out of bounds");
  return e;
}, i = (e, t) => t === "all" ? !0 : t.includes(e.id);
export {
  i as getDisabledState,
  r as getLastListWithOrder,
  o as insertAt
};
//# sourceMappingURL=SavedList.helpers.es.js.map
